module.exports = __webpack_public_path__ + "static/media/ngrx.957b026a.svg";